/*!
	Autosize 3.0.5
	license: MIT
	http://www.jacklmoore.com/autosize
*/
!function (e, t) { if ("function" == typeof define && define.amd) define(["exports", "module"], t); else if ("undefined" != typeof exports && "undefined" != typeof module) t(exports, module); else { var o = { exports: {} }; t(o.exports, o), e.autosize = o.exports } }(this, function (e, t) { "use strict"; function o(e) { function t() { var t = window.getComputedStyle(e, null); "vertical" === t.resize ? e.style.resize = "none" : "both" === t.resize && (e.style.resize = "horizontal"), l = "content-box" === t.boxSizing ? -(parseFloat(t.paddingTop) + parseFloat(t.paddingBottom)) : parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth), n() } function o(t) { var o = e.style.width; e.style.width = "0px", e.offsetWidth, e.style.width = o, u = t, a && (e.style.overflowY = t), n() } function n() { var t = e.style.height, n = document.documentElement.scrollTop, i = document.body.scrollTop, r = e.style.height; e.style.height = "auto"; var d = e.scrollHeight + l; if (0 === e.scrollHeight) return void (e.style.height = r); e.style.height = d + "px", document.documentElement.scrollTop = n, document.body.scrollTop = i; var s = window.getComputedStyle(e, null); if (s.height !== e.style.height) { if ("visible" !== u) return void o("visible") } else if ("hidden" !== u) return void o("hidden"); if (t !== e.style.height) { var a = document.createEvent("Event"); a.initEvent("autosize:resized", !0, !1), e.dispatchEvent(a) } } var i = void 0 === arguments[1] ? {} : arguments[1], r = i.setOverflowX, d = void 0 === r ? !0 : r, s = i.setOverflowY, a = void 0 === s ? !0 : s; if (e && e.nodeName && "TEXTAREA" === e.nodeName && !e.hasAttribute("data-autosize-on")) { var l = null, u = "hidden", v = function (t) { window.removeEventListener("resize", n), e.removeEventListener("input", n), e.removeEventListener("keyup", n), e.removeAttribute("data-autosize-on"), e.removeEventListener("autosize:destroy", v), Object.keys(t).forEach(function (o) { e.style[o] = t[o] }) }.bind(e, { height: e.style.height, resize: e.style.resize, overflowY: e.style.overflowY, overflowX: e.style.overflowX, wordWrap: e.style.wordWrap }); e.addEventListener("autosize:destroy", v), "onpropertychange" in e && "oninput" in e && e.addEventListener("keyup", n), window.addEventListener("resize", n), e.addEventListener("input", n), e.addEventListener("autosize:update", n), e.setAttribute("data-autosize-on", !0), a && (e.style.overflowY = "hidden"), d && (e.style.overflowX = "hidden", e.style.wordWrap = "break-word"), t() } } function n(e) { if (e && e.nodeName && "TEXTAREA" === e.nodeName) { var t = document.createEvent("Event"); t.initEvent("autosize:destroy", !0, !1), e.dispatchEvent(t) } } function i(e) { if (e && e.nodeName && "TEXTAREA" === e.nodeName) { var t = document.createEvent("Event"); t.initEvent("autosize:update", !0, !1), e.dispatchEvent(t) } } var r = null; "undefined" == typeof window || "function" != typeof window.getComputedStyle ? (r = function (e) { return e }, r.destroy = function (e) { return e }, r.update = function (e) { return e }) : (r = function (e, t) { return e && Array.prototype.forEach.call(e.length ? e : [e], function (e) { return o(e, t) }), e }, r.destroy = function (e) { return e && Array.prototype.forEach.call(e.length ? e : [e], n), e }, r.update = function (e) { return e && Array.prototype.forEach.call(e.length ? e : [e], i), e }), t.exports = r });

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright Â© 2001 Robert Penner
 * All rights reserved.
 *
 * TERMS OF USE - jQuery Easing
 * 
 * Open source under the BSD License. 
 * 
 * Copyright Â© 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
*/
jQuery.easing.jswing = jQuery.easing.swing; jQuery.extend(jQuery.easing, { def: "easeOutQuad", swing: function (e, f, a, h, g) { return jQuery.easing[jQuery.easing.def](e, f, a, h, g) }, easeInQuad: function (e, f, a, h, g) { return h * (f /= g) * f + a }, easeOutQuad: function (e, f, a, h, g) { return -h * (f /= g) * (f - 2) + a }, easeInOutQuad: function (e, f, a, h, g) { if ((f /= g / 2) < 1) { return h / 2 * f * f + a } return -h / 2 * ((--f) * (f - 2) - 1) + a }, easeInCubic: function (e, f, a, h, g) { return h * (f /= g) * f * f + a }, easeOutCubic: function (e, f, a, h, g) { return h * ((f = f / g - 1) * f * f + 1) + a }, easeInOutCubic: function (e, f, a, h, g) { if ((f /= g / 2) < 1) { return h / 2 * f * f * f + a } return h / 2 * ((f -= 2) * f * f + 2) + a }, easeInQuart: function (e, f, a, h, g) { return h * (f /= g) * f * f * f + a }, easeOutQuart: function (e, f, a, h, g) { return -h * ((f = f / g - 1) * f * f * f - 1) + a }, easeInOutQuart: function (e, f, a, h, g) { if ((f /= g / 2) < 1) { return h / 2 * f * f * f * f + a } return -h / 2 * ((f -= 2) * f * f * f - 2) + a }, easeInQuint: function (e, f, a, h, g) { return h * (f /= g) * f * f * f * f + a }, easeOutQuint: function (e, f, a, h, g) { return h * ((f = f / g - 1) * f * f * f * f + 1) + a }, easeInOutQuint: function (e, f, a, h, g) { if ((f /= g / 2) < 1) { return h / 2 * f * f * f * f * f + a } return h / 2 * ((f -= 2) * f * f * f * f + 2) + a }, easeInSine: function (e, f, a, h, g) { return -h * Math.cos(f / g * (Math.PI / 2)) + h + a }, easeOutSine: function (e, f, a, h, g) { return h * Math.sin(f / g * (Math.PI / 2)) + a }, easeInOutSine: function (e, f, a, h, g) { return -h / 2 * (Math.cos(Math.PI * f / g) - 1) + a }, easeInExpo: function (e, f, a, h, g) { return (f == 0) ? a : h * Math.pow(2, 10 * (f / g - 1)) + a }, easeOutExpo: function (e, f, a, h, g) { return (f == g) ? a + h : h * (-Math.pow(2, -10 * f / g) + 1) + a }, easeInOutExpo: function (e, f, a, h, g) { if (f == 0) { return a } if (f == g) { return a + h } if ((f /= g / 2) < 1) { return h / 2 * Math.pow(2, 10 * (f - 1)) + a } return h / 2 * (-Math.pow(2, -10 * --f) + 2) + a }, easeInCirc: function (e, f, a, h, g) { return -h * (Math.sqrt(1 - (f /= g) * f) - 1) + a }, easeOutCirc: function (e, f, a, h, g) { return h * Math.sqrt(1 - (f = f / g - 1) * f) + a }, easeInOutCirc: function (e, f, a, h, g) { if ((f /= g / 2) < 1) { return -h / 2 * (Math.sqrt(1 - f * f) - 1) + a } return h / 2 * (Math.sqrt(1 - (f -= 2) * f) + 1) + a }, easeInElastic: function (f, h, e, l, k) { var i = 1.70158; var j = 0; var g = l; if (h == 0) { return e } if ((h /= k) == 1) { return e + l } if (!j) { j = k * 0.3 } if (g < Math.abs(l)) { g = l; var i = j / 4 } else { var i = j / (2 * Math.PI) * Math.asin(l / g) } return -(g * Math.pow(2, 10 * (h -= 1)) * Math.sin((h * k - i) * (2 * Math.PI) / j)) + e }, easeOutElastic: function (f, h, e, l, k) { var i = 1.70158; var j = 0; var g = l; if (h == 0) { return e } if ((h /= k) == 1) { return e + l } if (!j) { j = k * 0.3 } if (g < Math.abs(l)) { g = l; var i = j / 4 } else { var i = j / (2 * Math.PI) * Math.asin(l / g) } return g * Math.pow(2, -10 * h) * Math.sin((h * k - i) * (2 * Math.PI) / j) + l + e }, easeInOutElastic: function (f, h, e, l, k) { var i = 1.70158; var j = 0; var g = l; if (h == 0) { return e } if ((h /= k / 2) == 2) { return e + l } if (!j) { j = k * (0.3 * 1.5) } if (g < Math.abs(l)) { g = l; var i = j / 4 } else { var i = j / (2 * Math.PI) * Math.asin(l / g) } if (h < 1) { return -0.5 * (g * Math.pow(2, 10 * (h -= 1)) * Math.sin((h * k - i) * (2 * Math.PI) / j)) + e } return g * Math.pow(2, -10 * (h -= 1)) * Math.sin((h * k - i) * (2 * Math.PI) / j) * 0.5 + l + e }, easeInBack: function (e, f, a, i, h, g) { if (g == undefined) { g = 1.70158 } return i * (f /= h) * f * ((g + 1) * f - g) + a }, easeOutBack: function (e, f, a, i, h, g) { if (g == undefined) { g = 1.70158 } return i * ((f = f / h - 1) * f * ((g + 1) * f + g) + 1) + a }, easeInOutBack: function (e, f, a, i, h, g) { if (g == undefined) { g = 1.70158 } if ((f /= h / 2) < 1) { return i / 2 * (f * f * (((g *= (1.525)) + 1) * f - g)) + a } return i / 2 * ((f -= 2) * f * (((g *= (1.525)) + 1) * f + g) + 2) + a }, easeInBounce: function (e, f, a, h, g) { return h - jQuery.easing.easeOutBounce(e, g - f, 0, h, g) + a }, easeOutBounce: function (e, f, a, h, g) { if ((f /= g) < (1 / 2.75)) { return h * (7.5625 * f * f) + a } else { if (f < (2 / 2.75)) { return h * (7.5625 * (f -= (1.5 / 2.75)) * f + 0.75) + a } else { if (f < (2.5 / 2.75)) { return h * (7.5625 * (f -= (2.25 / 2.75)) * f + 0.9375) + a } else { return h * (7.5625 * (f -= (2.625 / 2.75)) * f + 0.984375) + a } } } }, easeInOutBounce: function (e, f, a, h, g) { if (f < g / 2) { return jQuery.easing.easeInBounce(e, f * 2, 0, h, g) * 0.5 + a } return jQuery.easing.easeOutBounce(e, f * 2 - g, 0, h, g) * 0.5 + h * 0.5 + a } });


/******************************************************************
 *
 *  PLEASE NOTE!
 *
 *  This JavaScript file contains scripts exported from the
 *  HubSpot project that can be used in the Epi site.
 *
 */

// @codekit-prepend "vendor/autosize-master/dist/autosize.min.js";
// @codekit-prepend "vendor/jquery.easing.min.js";

// @ codekit-append "utils/Zooma/Tools/ZO.helper.js";
// @ codekit-append "utils/Zooma/Tools/ZO.configure.js";
// @ codekit-append "utils/Zooma/Tools/ZO.configure.js";
// @codekit-append "utils/Zooma/Tools/debugLog.js";
// @codekit-append "utils/Zooma/HubSpotTools/ZO.hsCookie.js";

// add '@' the following declarations to also include these files

// @codekit-append "utils/Zooma/HubSpotForms/FormJutsu/jquery.hsFormSharingan.js";
// @codekit-append "utils/Zooma/HubSpotForms/FormJutsu/jquery.hsFormTsukuyomi.js";
// @codekit-append "utils/Zooma/HubSpotForms/FormJutsu/jquery.hsFloatedLabels.js";


/****************************************************
 *
 * debugLog.js v1.1.3
 *
 * Written by Yeu-Kang Hua
 *
 * @copyright Yeu-Kang Hua
 *
 */

window.debugLog = (function () {

    "use strict";

    ///////////////////////////////////////////////////////////////////////
    // Private methods & properties
    ///////////////////////////////////////////////////////////////////////

    // --------------------------------
    //  Debug helper function
    // --------------------------------

    var debugLog = {
        enabled: false,
        sepChar: '-',
        sepLen: 90,
        sepStartLen: 5,
        msgSep: ' ',
        setEnabled: function (val) {
            this.enabled = val;
        },
        getEnabled: function () {
            return this.enabled;
        },
        log: function (str) {
            if (window.console && window.console.info) {
                window.console.info(str);
            }
        },
        add: function () {
            if (this.enabled) {
                var str = '',
                    strBegan = false,
                    i;

                for (i in arguments) {
                    if (arguments[i] !== undefined) {
                        if (typeof arguments[i] == 'object' || arguments[i].constructor == Array) {
                            if (strBegan) {
                                this.log(str);
                                str = '';
                                strBegan = false;
                            }
                            this.log(arguments[i]);
                        } else {
                            if (strBegan) str += this.msgSep;
                            str += arguments[i];
                            strBegan = true;
                        }
                    } else {
                        if (strBegan) str += this.msgSep;
                        str += 'null';
                        strBegan = true;
                    }
                }

                if (strBegan) this.log(str);
            }
        },
        newSection: function (str) {
            if (this.enabled) {

                this.log('');

                if (str !== undefined) {
                    var len = this.sepLen - str.length - this.sepStartLen - 1;
                    var ending = len > 0 ? new Array(len).join(this.sepChar) : new Array(this.sepStartLen).join(this.sepChar);
                    this.log(new Array(this.sepStartLen).join(this.sepChar) + ' ' + str.toUpperCase() + ' ' + ending);
                } else {
                    this.log(new Array(this.sepLen).join(this.sepChar));
                }
            }
        },
        endSection: function () {
            if (this.enabled) {
                this.log(new Array(this.sepLen).join(this.sepChar));
                this.log('');
            }
        }
    };



    /****************************************************
     *
     *  pr() -- Helper function for quick logging
     *
     *  Does not currently support multiple arguments
     *
     */

    if (!window.pr) {
        window.pr = function (val) {
            debugLog.add(val);
        };
    }

    /****************************************************
     *
     *  Make it possible to enable/disable debugging
     *  using a debug query string parameter.
     *
     */

    if (!window.getUrlParamByName) {
        window.getUrlParamByName = function (sParam) {
            var sPageURL = window.location.search.substring(1);
            var sURLVariables = sPageURL.split('&');
            for (var i = 0; i < sURLVariables.length; i++) {
                var sParameterName = sURLVariables[i].split('=');
                if (sParameterName[0] == sParam) {
                    return sParameterName[1];
                }
            }
            return '';
        };
    }

    ///////////////////////////////////////////////////////////////////////
    // Public API
    ///////////////////////////////////////////////////////////////////////

    return debugLog;

})();

/****************************************************
 *
 *  IE9 fix
 *
 */

if (!window.console) {
    window.console = {
        log: function () { },
        warn: function () { },
        error: function () { },
        time: function () { },
        timeEnd: function () { }
    };
}

// Doc ready
(function ($) {
    $(function () {
        if (window.getUrlParamByName('debug') == 1 || window.getUrlParamByName('local') == 1 || window.location.hostname.indexOf('.local') !== -1) {
            debugLog.setEnabled(true);
        }
    });

})(jQuery);

/*

 Zooma HubSpot Cookie v1.6217
 ----------------------------

 Dependencies:
 https://github.com/js-cookie/js-cookie

 How to use:
 var hsCookie = ZO.hsCookie.getInstance();

 */

if (!Cookies) {
    throw new Error("Javascript Cookie must be loaded!");
}

window.ZO = window.ZO || {};

ZO.hsCookie = (function () {

    "use strict";

    var instance; // prevent modification of "instance" variable

    function init() {

        /****************************************
         *
         *      PRIVATE METHODS & PROPERTIES
         *
         */

        var _domain = '';


        function _setDomain(domain) {
            _domain = domain;
        }

        function _getDomain() {
            return _domain;
        }

        /****************************************
         *
         *      PUBLIC METHODS & PROPERTIES
         *
         */

        return {

            init: function (domain) {
                if (domain == undefined) {
                    domain = window.location.hostname;
                    domain = domain.substr(domain.indexOf('.'), domain.length - domain.indexOf('.'));
                }
                _setDomain(domain);

            },

            initOneTrustForHubSpot: function () {
                this.init()
                const marketingOneTrustCategoryId = window.requiredMarketingCookieCategory;

                if ( typeof window.OnetrustActiveGroups === 'string'
                     && !window.OnetrustActiveGroups.includes(marketingOneTrustCategoryId)) {

                    //
                    // Marketing cookies disabled by OneTrust
                    //
                    if (window._hsq != null) {
                        window._hsq.push(['doNotTrack', { track: false }]);
                        //window._hsq.push(['revokeCookieConsent']);
                        Cookies.set('__hs_opt_out', 'yes', {
                            path: '/',
                            domain: _getDomain(),
                            expires: 156
                        });

                        setTimeout(() => {
                            this.clearMarketingCookies();
                        }, 1000);
                    }
                } else if ( typeof window.OnetrustActiveGroups === 'string'
                            && window.OnetrustActiveGroups.includes(marketingOneTrustCategoryId)) {
                    //
                    // Marketing cookies enabled by OneTrust
                    //
                    if (window._hsq != null) {
                        window._hsq.push(['doNotTrack', { track: true }]);
                        window._hsq.push(['revokeCookieConsent']);
                    }
                }
            },

            clearMarketingCookies: function () {
                const success = Cookies.remove('hubspotutk', { path: '/' });
                Cookies.remove('__hstc', { path: '/' });
                Cookies.remove('__hssc', { path: '/' });
                Cookies.remove('__hssrc', { path: '/' });
                Cookies.remove('messagesUtk', { path: '/' });
                return success
            },

            clearCookie: function () {
                var success = false;

                success = Cookies.remove('hubspotutk', { path: '/', domain: _getDomain() });
                Cookies.remove('__hstc', { path: '/', domain: _getDomain() });

                // Experimental
                Cookies.remove('__hssc', { path: '/', domain: _getDomain() });
                Cookies.remove('hsfirstvisit', { path: '/', domain: _getDomain() });
                Cookies.remove('hsPagesViewedThisSession', { path: '/', domain: _getDomain() });

                return success;
            }

        };

    }

    return {

        // Get the Singleton instance if one exists
        // or create one if it doesn't
        getInstance: function () {

            if (!instance) {
                instance = init();
            }

            return instance;
        }

    };


})();

(function ($) {

    /**
     * hsFormSharingan v1.1.0
     *
     * This plugin searches for HubSpot forms inside a selector. After finding them,
     * hsFormSharingan will use hsFormTsukuyomi to inject or update property fields right
     * after the form initializations. If the HubSpot forms are inserted using the embed script,
     * use the 'embedded' option. hsFormSharingan will then wait for the embed process to finish.
     *
     * http://zooma.se
     * (c) 2015 Yeu-Kang Hua
     *
     * hsFormTsukuyomi may be freely distributed under the MIT license.
     */

    $.fn.hsFormSharingan = function (options) {

        var opts = $.extend({}, $.fn.hsFormSharingan.defaults, options),
            idSelectors = [
                'hsForm_',
                'hs_form_target_',
                'hs_form_target_widget',
                'hs_form_target_module',
                'hs_form_target_wizard_module',
                'hs_cos_wrapper_blog_comments',
                'comment-form'
            ];

        if (opts.embedded) {

            return this.each(function () {

                var $el = $(this),
                    id = $el.attr('id'),
                    timer,
                    startTime,
                    init = function () {

                        startTime = Date.now();

                        timer = setInterval(function () {

                            if ($el.find('.hs-form').length) {
                                // Added this selector 2017-02-24
                                clearInterval(timer);
                                $el.find('.hs-form').hsFormTsukuyomi(opts);

                            } else if ($el.find('.hbspt-form').length) {
                                clearInterval(timer);
                                //debugLog.add('Found an embedded form in', '#'+$el.find('.hbspt-form').attr('id'));
                                $el.find('.hbspt-form').hsFormTsukuyomi(opts);
                            }

                            if ((Date.now() - startTime) >= opts.timeOut) {
                                clearInterval(timer);
                                $el.remove();
                                debugLog.add('hsFormSharingan search for an embedded HubSpot timed out');
                            }

                        }, opts.speed);

                    };

                init();

            });

        } else {

            var selectors = '';
            for (let i in idSelectors) {
                selectors += '[id^="' + idSelectors[i] + '"]';
                selectors += i < (idSelectors.length - 1) ? ', ' : '';
            }
            //selectors += ', [data-form-id != ""]';

            if (this.attr('id') != undefined && (this.attr('id').indexOf('hs_form_target_widget') !== -1 || this.attr('id').indexOf('hs_form_target_module') != -1))
                var forms = this;
            else
                var forms = this.find(selectors);

            debugLog.add((forms.length == 1) ? 'Found 1 form in content' : 'Found ' + forms.length + ' forms in content');

            return forms.each(function () {

                if ($.fn.hsFormTsukuyomi !== undefined) {
                    $(this).hsFormTsukuyomi(opts);
                } else {
                    throw new Error("hsFormTsukuyomi has not been loaded yet!")
                }

            });
        }

    };

    $.fn.hsFormSharingan.defaults = {
        fields: {},
        embedded: false,
        timeout: 5000,
        callback: function () { },
        beforeCallback: function () { },
        speed: 50
    };

}(jQuery));

(function ($) {

    /**
     * hsFormTsukuyomi v1.1.1
     *
     * This plugin is used to inject new properties or update existing ones
     * to a HubSpot form in runtime, after the form has been initialized.
     *
     * http://zooma.se
     * (c) 2015 Yeu-Kang Hua
     *
     * hsFormTsukuyomi may be freely distributed under the MIT license.
     */

    if (!Object.size) {
        Object.size = function (obj) {
            var size = 0, key;
            for (key in obj) {
                if (obj.hasOwnProperty(key)) size++;
            }
            return size;
        };
    }

    $.fn.hsFormTsukuyomi = function (options) {

        var opts = $.extend({}, $.fn.hsFormSharingan.defaults, options),
            idSelectors = [
                'hsForm_',
                'hs_form_target_',
                'hs_form_target_widget',
                'hs_form_target_module',
                'hs_form_target_wizard_module',
                'hs_cos_wrapper_blog_comments',
                'comment-form'
            ],
            hasSelector = false,
            id;

        for (let i in idSelectors) {
            if (this.attr('id').indexOf([idSelectors[i]]) !== -1) {
                hasSelector = true;
            }
        }

        debugLog.add(this.attr('class'));
        if (!this.hasClass('hbspt-form') && !this.hasClass('hs-form') && !hasSelector) {
            throw new Error("hsFormTsukuyomi can't be performed on a non-HubSpot element")
        }

        return this.each(function () {

            var initiated = false,
                $el = $(this),
                id = $el.attr('id'),
                timer,
                startTime,
                addFields = function () {
                    var numFields = Object.size(opts.fields);

                    if (initiated && numFields > 0) {

                        var $tgt = $el.find('.hs_submit');
                        var html = '';
                        var added = 0;

                        // Create new fields
                        for (key in opts.fields) {
                            var value = opts.fields[key];
                            var $field = $el.find('.hs-input[name="' + key + '"]');

                            if ($field.length == 0) {
                                html = '<input class="hs-input" type="hidden" name="' + key + '" value="' + value + '"/>';
                                $tgt.prepend(html);
                                added++;
                            } else {
                                $field
                                    .val(value)
                                    .change(); // Set value to existing field
                            }
                        }

                        if (added > 0) debugLog.add('Created ' + added + ' new fields');
                        debugLog.add('Updated values on ' + numFields + ' fields');
                    }
                },
                init = function () {

                    startTime = Date.now();

                    timer = setInterval(function () {

                        if ($el.html() != '') {

                            initiated = true;

                            clearInterval(timer);

                            debugLog.newSection('#' + id);

                            opts.beforeCallback.call($el, $el);

                            addFields();

                            opts.callback.call($el, $el);
                        }

                        if ((Date.now() - startTime) >= opts.timeOut) {
                            clearInterval(timer);
                            debugLog.add('FGHubSpotForm timed out for #' + id);
                        }

                    }, opts.speed);

                };

            init();
        });

    };

    $.fn.hsFormTsukuyomi.defaults = {
        fields: {},
        timeout: 5000,
        callback: function () { },
        beforeCallback: function () { },
        speed: 50
    };

}(jQuery));

(function ($) {

    /**
     * hsFloatedLabels v1.2.3
     *
     *  Creates the floated label behaviour on HubSpot forms, where the label
     *  appears as a placeholder at first, but becomes the input label when
     *  the input field is focused.
     *
     * Dependencies:
     *  - hsFormSharingan
     *
     * How to use:
     *  1. Use hsFormSharingan to sniff up forms on the page
     *  2. In the init callback, apply $form.hsFloatedLabels()
     *
     * Example code:
     *  $('.hs_cos_wrapper_type_form').hsFormSharingan({
     *      callback: function () {
     *          $(this).hsFloatedLabels();
     *      }
     *  });
     *
     *
     * Notes
     * ---------------------------------------------------------------------
     *
     * 2017-01-04
     * Added following:
     * - Support for custom select inputs, that are wrapped in .Select
     * - Skip class (hs-floated-label-disabled) for both inputs and
     *   custom select
     * - option to enable placeholders, for example "email@example.com"
     *
     * 2017-01-05
     * - Reworked the floated labels wrapper to fix a nasty bug with
     *   HubSpot forms. Apparently you can't wrap the input because
     *   the modified DOM causes problems with the React forms.
     *
     * 2017-01-09
     * - Added option "floatOnValue" that enables the floating labels
     *   first when a value has been entered in a text field.
     *
     * 2017-01-21
     * - Added a input update trigger after initializing to handle
     *   auto populated values
     *
     * http://zooma.se
     * (c) 2016-2017 Yeu-Kang Hua
     *
     * hsFloatedLabels may be freely distributed under the MIT license.
     */

    $.fn.hsFloatedLabels = function (options) {

        var opts = $.extend({}, $.fn.hsFloatedLabels.defaults, options);

        return this.find('.hs-form-field').each(function () {

            var $input = $(this).find('input[type="text"], input[type="email"], input[type="number"], input[type="password"],  input[type="tel"], textarea'),
                $label = $(this).find('label'),
                $customSelect = $(this).find('.Select'),
                isTextInput = ($(this).find('input[type="radio"], input[type="checkbox"], input[type="file"], select').length == 0),
                hasCustomSelect = $customSelect.length;

            if (isTextInput && !$input.hasClass(opts.disabledClass) && $(this).find('.hs-floated-label-input').length == 0) {

                $(this)
                    .addClass(opts.wrapClass)
                    .addClass(opts.textInputClass);

                if (opts.floatOnValue) {
                    $(this)
                        .addClass(opts.floatOnValueClass)
                        .append('<span class="' + opts.placeholderClass + '">' + $(this).find('> label').html() + '</span>'); // Create extra placeholder
                }

                var $inputWrapper = $(this);

                // If input already contains value (prepopulated), add the pinned class
                if ($input.val() !== '') {
                    $inputWrapper.addClass(opts.pinnedClass);
                }
                // If legend is available, add a class to handle additional spacings
                if ($(this).find('legend').text().length != 0) {
                    $inputWrapper.addClass(opts.hasLegendClass);
                }

                // Save placeholder
                if (opts.enablePlaceholder) {
                    var placeholder = $input.attr('placeholder') ? $input.attr('placeholder') : '';
                    $input.data('placeholder', placeholder);
                }

                $input.removeAttr('placeholder'); // Become the captain now

                $input
                    .on('keydown', function (e) {
                        // Not a modifier key and not backspace or delete
                        if (!e.metaKey && !e.shiftKey && !e.ctrlKey && e.keyCode != 8 && e.keyCode != 46) {
                            $inputWrapper.addClass(opts.hasValueClass);
                        }
                    })
                    .on('keyup', function () {
                        if ($(this).val() != "") {
                            $inputWrapper.addClass(opts.hasValueClass);
                        } else {
                            $inputWrapper.removeClass(opts.hasValueClass);
                        }
                    })
                    .on('focus', function () {
                        $inputWrapper.addClass(opts.focusedClass);
                        // Restore placeholder if enabled
                        if (opts.enablePlaceholder) {
                            $(this).attr('placeholder', $(this).data('placeholder'));
                        }
                        // Fix to enable placeholder even in "float on value" setting
                        if (opts.enablePlaceholder && opts.floatOnValue && $(this).attr('placeholder')) {
                            $inputWrapper.addClass(opts.hasValueClass);
                        }
                    })
                    .on('blur', function () {
                        if ($input.val() == '') {
                            $inputWrapper
                                .removeClass(opts.pinnedClass)
                                .removeClass(opts.hasValueClass);

                            // Clear placeholder if no text has been entered
                            if (opts.enablePlaceholder) {
                                $(this).attr('placeholder', '');
                            }
                        } else {
                            $inputWrapper.addClass(opts.pinnedClass);
                            $input.trigger('change');
                        }
                        $inputWrapper.removeClass(opts.focusedClass);
                    });


                // Handle auto populated values
                if ($input.is('textarea')) {
                    // For some reason auto populated textareas come with a delay...
                    setTimeout(function () {
                        $input.trigger('blur');
                    }, 500);
                } else {
                    $input.trigger('blur');
                }

            } else if (hasCustomSelect && !$customSelect.hasClass(opts.disabledClass) && $(this).find('.hs-floated-label-input').length == 0) {

                $(this).append('<div class="' + opts.wrapClass + ' ' + opts.selectInputClass + '"></div>');
                var $customSelectWrapper = $(this).find('.' + opts.wrapClass);

                // If input already contains value (prepopulated), add the pinned class
                if ($customSelect.val() !== '') {
                    $customSelectWrapper.addClass(opts.pinnedClass);
                }
                // If legend is available, add a class to handle additional spacings
                if ($(this).find('legend').text().length != 0) {
                    $customSelectWrapper.addClass(opts.hasLegendClass);
                }

                $label.appendTo($customSelectWrapper);
                $customSelect = $customSelect.appendTo($customSelectWrapper);

                // Save default option label and then hide it
                var defaultLabel = $(this).find('option:first[value=""]').text();
                $(this).find('option:first[value=""]')
                    .data('label', defaultLabel)
                    .text('');

                $customSelect.find('select')
                    .removeAttr('placeholder') // Become the captain now
                    .on('focus', function () {
                        $customSelectWrapper.addClass(opts.focusedClass);
                        // Restore default option label
                        var $defaultOption = $(this).find('option:first[value=""]');
                        $defaultOption.text($defaultOption.data('label'));
                    })
                    .on('blur', function () {
                        if ($(this).find('option:selected').val() == "") {
                            $customSelectWrapper.removeClass(opts.pinnedClass);

                            // Clear default option label when nothing is selected
                            var $defaultOption = $(this).find('option:first[value=""]');
                            $defaultOption.text('');
                        } else {
                            $customSelectWrapper.addClass(opts.pinnedClass);
                        }
                        $customSelectWrapper.removeClass(opts.focusedClass);
                    });

                // Handle auto populated values
                $customSelect.find('select').trigger('blur');
            }

            // Add initiated class to enable transitions
            var $inputItem = $(this);
            setTimeout(function () {
                $inputItem.addClass('hs-floated-label-input--initiated');
            }, 500);
        });

    };

    $.fn.hsFloatedLabels.defaults = {
        floatOnValue: false,        // Set floating first when field has a value
        wrapClass: 'hs-floated-label-input',
        floatOnValueClass: 'hs-floated-label-input--float-on-value',
        placeholderClass: 'hs-floated-label-placeholder',
        disabledClass: 'hs-floated-label-disabled',
        textInputClass: 'hs-text-input',
        selectInputClass: 'hs-select-input',
        hasValueClass: 'has-value',
        focusedClass: 'focused',
        pinnedClass: 'pinned',     // Value has been entered in input field
        enablePlaceholder: false,
        hasLegendClass: 'has-legend'  // Field has a legend (description)
    };

}(jQuery));